import classname from 'classnames'
import { useEffect, useRef, useState } from 'react'
import { deepMap } from 'react-children-utilities'
import { usePopper } from 'react-popper'
import { ReactComponent as IconChevron } from '@/assets/svgs/profile-chevron.svg'
import KeyboardEventHandler from '@infinium/react-keyboard-event-handler'
import InputSuffixIcon from '@/components/InputSuffixIcon'
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import Search from '@/componentsDS/Search/index';
import { feature, features } from "@/utils/feature-verifier";

const Item = () => null

const dropdownItemClassNames = (value, firstChild) => [
	'dropdown__item',
	value && value === firstChild?.props?.id ? 'dropdown__item__selected' : '',
	firstChild.props.disabled ? 'dropdown__item--disabled' : ''
];

const Dropdown = ({ children, placeholder, value, filterVisible, placement = 'bottom-start', disabled, ...rest }) => {
	const [filterValue, setFilterValue] = useState('')
	const items = deepMap(children, firstChild => {
		if (firstChild.type === Item) {
			const item = deepMap(firstChild.props.children, (child, childIndex) => {
				if (filterValue?.length > 0) {
					if (!firstChild?.props?.id?.toLowerCase()?.includes(filterValue?.toLowerCase())) {
						return null
					}
				}
				return (
					<div className={classname(dropdownItemClassNames(value, firstChild))} onClick={(event) => {
						handleDropdownClick(event)
						typeof firstChild?.props?.onClick === 'function' && firstChild.props.onClick(event)
					}} key={childIndex}>{child}</div>
				)
			})
			return item
		}
		return firstChild
	})

	const [visible, setVisibility] = useState(false)

	const referenceRef = useRef(null)
	const popperRef = useRef(null)

	const { styles, attributes, update } = usePopper(
		referenceRef.current,
		popperRef.current,
		{
			placement,
			modifiers: [
				{
					name: 'offset',
					enabled: true,
					options: {
						offset: [0, 5]
					}
				},
			]
		},
	)

	useEffect(() => {
		if (visible && typeof update === "function") {
			requestAnimationFrame(() => {
				update();
			});
		}
	}, [visible, update]);


	const dropdownClass = classname({
		'dropdown__content': true,
		'dropdown__content--active': visible
	})

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

	function handleDocumentClick(event) {
		if (referenceRef.current?.contains(event.target) || popperRef.current?.contains(event.target)) {
			return
		}
		setVisibility(false)
		setFilterValue('');
	}

	function handleDropdownClick(_event) {
		setVisibility(!visible)
		setFilterValue('');
	}

	return (
		<div className="dropdown" {...rest}>
			<KeyboardEventHandler isExclusive={visible} handleKeys={["esc"]} onKeyEvent={(_key, _e) => {
				setVisibility(false)
				setFilterValue('');
			}} />
			<div className={`dropdown__select ${disabled ? "dropdown--disabled" : ""}`} ref={referenceRef} onClick={handleDropdownClick} data-testid="dropdown-select">
				{value ? <span className='trim'>{value}</span> : <span className={`dropdown__placeholder ${disabled ? "dropdown__placeholder--disabled" : ""}`}>{placeholder}</span>}
				<div className="dropdown__select__icon">
					<IconChevron />
				</div>
			</div>
			{!disabled && (
				<div
					className='dropdown__value'
					ref={popperRef} style={{
						...styles.popper
					}} {...attributes.popper}>

					<div className={dropdownClass} data-testid="dropdown-content">
						{filterVisible && <div className="dropdown__filter">
						{
							<Search
								value={filterValue}
								placeholder="Search"
								onChange={(e) => setFilterValue(e?.target.value)}
								onCancel={() => setFilterValue('')}
								variant='filled'
							/>
						}
						</div>}
						{items}
					</div>
				</div>
			)}

		</div>
	)
}

Dropdown.Item = Item

export default Dropdown
